import React from "react";
import { useParams } from "react-router-dom";
import { ReviewForm } from "../components/form/ReviewForm";
import useFetchReview from "../hooks/useFetchReview";
import { Typography, Alert, Box } from "@mui/material";

export const ReviewPage = () => {
  let { token } = useParams();
  const { data, error, loading } = useFetchReview(token);

  if (loading) {
    return null;
  }

  if (error) {
    return (
      <Box id="page" sx={{ mt: 4 }}>
        <Alert severity="error">{error.message}</Alert>
      </Box>
    );
  }

  if (data.course.used) {
    return (
      <Box id="page" sx={{ mt: 4 }}>
        <Alert severity="info">{error.message}</Alert>
      </Box>
    );
  }

  return (
    <Box id="page" sx={{ mt: 4 }}>
      <Typography variant="h5" sx={{ mt: 4 }}>
        {data.course.code} - {data.course.title}
      </Typography>
      <Typography variant="subtitle1" sx={{ mb: 2 }}>
        {data.date}
      </Typography>
      <ReviewForm />
    </Box>
  );
};
